import type React from 'react';
import { Box, Card, Heading, Icon, Paragraph, Text } from '@zillow/constellation-10';
import { IconDollarSignCircleFilled, IconHouseUserFilled, IconSearchFilled } from '@zillow/constellation-icons';
import { ClickstreamAuthTriggerSource, ClickstreamTriggerObject } from '../../analytics/events';
import FlexibleLandlordIcon from '../../assets/FlexibleLandlord.svg';
import Image from 'next/image';
import { BenefitSection } from './elements/BenefitSection';
import RequestZillowPaymentsModal from './elements/RequestZillowPaymentsModal';

export default function PrivacyNoticeScreen() {
  return (
    <Box css={{ marginTop: '{spacing.800}' }}>
      <Box
        css={{
          display: 'flex',
          gap: '{spacing.1000}',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          flexDirection: 'column',
          '@media (min-width: 1024px)': {
            flexDirection: 'row',
          },
        }}
      >
        <Box css={{ flex: 1, maxWidth: '762px' }}>
          <Heading level={3} css={{ marginBottom: '{spacing.800}' }}>
            Here&apos;s how it works
          </Heading>

          <Box css={{ marginBottom: '{spacing.800}' }}>
            <BenefitSection
              icon={
                <Icon size="xl" css={{ color: 'icon.onImpact.feedback.info.strong' }}>
                  <IconHouseUserFilled />
                </Icon>
              }
              title="Enter your personal details"
              backgroundColor="black"
            >
              Sign in or create a Zillow account. We&apos;ll share your email with our partner, Esusu, to set up rent
              reporting and credit monitoring on Zillow.
            </BenefitSection>

            <BenefitSection
              icon={
                <Icon size="xl" css={{ color: 'icon.onImpact.feedback.info.strong' }}>
                  <IconDollarSignCircleFilled />
                </Icon>
              }
              title="Link your bank account"
              backgroundColor="black"
            >
              Using Plaid, securely connect your bank account.
            </BenefitSection>

            <BenefitSection
              icon={
                <Icon size="xl" css={{ color: 'icon.onImpact.feedback.info.strong' }}>
                  <IconSearchFilled />
                </Icon>
              }
              title="Identify past rent payments"
              backgroundColor="black"
            >
              Choose your rent payments from the past 24 months.
            </BenefitSection>
          </Box>

          <Paragraph css={{ fontSize: '{fontSizes.450}', marginBottom: '{spacing.800}' }}>
            Sign up today for just <strong>$20 yearly.</strong>
          </Paragraph>
        </Box>

        <Card
          elevated={false}
          css={{
            width: '100%',
            padding: '{spacing.default}',
            alignSelf: 'flex-start',
            '@media (min-width: 1024px)': {
              width: '320px',
              maxWidth: '320px',
            },
          }}
        >
          <Box css={{ marginBottom: '{spacing.400}' }}>
            <Image src={FlexibleLandlordIcon} alt="Flexible landlord" width={104} height={104} />
          </Box>

          <Text textStyle="body-bold">Is your landlord flexible?</Text>

          <Paragraph
            css={{
              fontSize: '{fontSizes.400}',
              textAlign: 'left',
              marginBottom: '{spacing.400}',
            }}
          >
            Ask them to pay rent with Zillow and get access to rent reporting for <strong>free.</strong>
          </Paragraph>

          <Box css={{ textAlign: 'left' }}>
            <RequestZillowPaymentsModal
              ctaText="Request Zillow payments"
              clickstreamTriggerObject={ClickstreamTriggerObject.WIZARD_UPSELL}
              authTriggerSource={ClickstreamAuthTriggerSource.ZRM_REQUEST_UPSELL}
            />
          </Box>
        </Card>
      </Box>
    </Box>
  );
}
